import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  isactive: string;
  setTab: (value: string) => void;
  savedLyrics: boolean;
}
const Tabs = ({ isactive, setTab, savedLyrics }: IProps) => {
  return (
    <Container>
      <TabContainer>
        <TabItem
          isactive={isactive === "plain" ? "true" : "false"}
          onClick={() => setTab("plain")}
        >
          <Typography>Plain Lyrics</Typography>
        </TabItem>
        <TabItem
          isactive={isactive === "sync" ? "true" : "false"}
          onClick={() => savedLyrics && setTab("sync")}
        >
          <Typography>Sync Lyrics</Typography>
        </TabItem>
        <TabItem
          isactive={isactive === "credits" ? "true" : "false"}
          onClick={() => setTab("credits")}
        >
          <Typography>Credits</Typography>
        </TabItem>
      </TabContainer>
    </Container>
  );
};

export default Tabs;

const Container = styled.div`
  width: 100%;
  padding: 1.4rem 6.4rem;
  border-bottom: 1px solid ${Colors.grey700};
  margin-bottom: 2.4rem;
  @media only screen and (max-width: 769px) {
    padding: 1.6rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const TabContainer = styled.div`
  width: fit-content;
  padding: 0.4rem;
  border: 1px solid ${Colors.grey700};
  border-radius: 0.8rem;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 0.8rem;
`;

const TabItem = styled.div<{ isactive: string }>`
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.6rem;
  color: ${(props) =>
    props.isactive === "true" ? Colors.white100 : Colors.grey500};
  background-color: ${(props) =>
    props.isactive === "true" ? Colors.grey700 : "transparent"};

  @media only screen and (max-width: 769px) {
    padding: 1.2rem;
  }
`;
